export default __webpack_public_path__ + "static/media/wine-pair.221db5eb.svg";